import * as React from 'react'
import { translate } from 'react-translate'
const allowClientsCategoryIds = [AccountCategories.centralClearingParty, AccountCategories.introducingBroker, AccountCategories.fullMember]

class MdClientSelect extends React.Component<MdClientSelectProps, MdClientSelectState> {

  constructor(props: any) {
    super(props)
    this.state = {
      accountList: [],
      focused: false,
      selectedIndex: -1,
      selectedAccount: null,
      filter: ''
    }
  }

  private filterAccounts (inputString?) {
    var filterString = inputString || ''
    const Account = window['md3'].account
    var activeAccount = Account.getActive()

    let accountList = _.filter(Account.getAll(), (account: any) => {
      if (this.props.hideIbs) {
        // remove IBs if they should be hidden
        if (account.accountTypeId === 296) {
          return false
        }
      }
      if (this.props.hideHouse ||
        (_.get(activeAccount, 'categoryId') === AccountCategories.introducingBroker)
      ) {
        // Remove house account if it should be hidden
        if (activeAccount.id === account.id) {
          return false
        }
        // Show house account if it is searched
      }
      if (this.props.allowClientsOnly) {
        if (allowClientsCategoryIds.indexOf(account['categoryId']) === -1) {
          return false
        }
      }
      if (this.props.tradeClientsOnly) {
        // Only show accounts that are tradeable
        let metaldeskActive = account['metaldesk.active'] === true
        let accountDescendantPermission = window['md3'].adp.get(account.id)
        let allowClientTrade = accountDescendantPermission && accountDescendantPermission.allowClientTrade === true
        if (!metaldeskActive && !allowClientTrade) {
          return false
        }
      }
      if ('house'.indexOf(filterString.toLowerCase()) !== -1 && activeAccount.id === account.id && !this.props.hideHouse) {
        return true
      }
      let validName = (account.name || '').toLowerCase().indexOf(filterString.toLowerCase()) !== -1
      let validHin = (account.hin || '').toLowerCase().indexOf(filterString.toLowerCase()) !== -1
      let validStatus = account.accountStatus === 'active'
      let searchMatch = (validName || validHin) && validStatus
      return searchMatch
    })

    this.setState({
      accountList: accountList,
      filter: filterString
    })

  }

  public selectAccount(account, e) {
    e.preventDefault()
    if (!account) { return }

    var displayName = account.getDisplayName()

    this.setState({
      filter: _.get(account, 'metaldesk.active', false) ? 'House' : displayName,
      focused: false,
      selectedAccount: account
    })

    this.props.onAccountChange(account)
  }

  public handleInputChange(e) {
    e.preventDefault()
    this.filterAccounts(e.target.value)
  }

  public resetSelection (takeFocus) {
    this.setState({
      selectedIndex: -1,
      selectedAccount: null,
      filter: '',
      focused: takeFocus
    })
    this.filterAccounts()
    this.props.onAccountChange(null)
  }

  public formatValue(account) {
    return account
  }

  private focus() {
    this.setState({
      focused: true
    })
  }

  private unfocus() {
    this.setState({
      focused: false
    })
  }

  public render() {
    let accountList = this.state.accountList
    let t = this.props.t
    return (
      <div>
        {(window['md3'].account.getAll().length > 1) ? (
          <nav className='client-selector-wrapper'>
            <div>
              <input
                onChange={this.handleInputChange.bind(this)}
                onFocus={() => this.focus()}
                onBlur={() => this.unfocus()}
                onClick={() => this.resetSelection(true)}
                value={this.state.filter}
                type='text'
                placeholder={t('PLACEHOLDER')}

              />
              <div
                className='closeIcon'
                onClick={() => this.resetSelection(false)}>&nbsp;</div>
            </div>
            {(this.state.focused) ? (
              <div className='clientList'>
                <ul>
                  {accountList.map((acc, id) => {
                    return <li key={id} onMouseDown={(e) => this.selectAccount(acc, e)}>
                      <span>{acc.getDisplayName()}</span>
                    </li>
                  })}
                </ul>
              </div>
            ) : (null)}
          </nav>
        ) : (null)}
      </div>
    )
  }
}

export default translate('MdClientSelect')(MdClientSelect)
export { MdClientSelect as MdClientSelectUnconnected }



// WEBPACK FOOTER //
// ./react/components/widgets/MdClientSelect.tsx